import { useState } from "react";
import { X } from "lucide-react";

const inputCls = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#C8A96B]/50";

export const AssistantLeadForm = ({ onSubmit, onDismiss }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) return setErr("Name and email are required.");
    setBusy(true); setErr(null);
    try { await onSubmit(form); }
    catch (ex) { setErr(ex.response?.data?.detail?.message || "Couldn't save that — please try again."); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="border-t border-[#C8A96B]/40 bg-[#FBF8F1] px-4 py-3 space-y-2" data-testid="assistant-lead-form">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-semibold text-[#0A2342]">Want Bryan to send you a personalized shortlist?</p>
        <button type="button" onClick={onDismiss} className="text-slate-400 hover:text-slate-600" aria-label="Dismiss" data-testid="assistant-lead-dismiss"><X className="w-4 h-4" /></button>
      </div>
      <input className={inputCls} placeholder="Your name *" value={form.name} onChange={set("name")} data-testid="assistant-lead-name" />
      <input className={inputCls} type="email" placeholder="Email *" value={form.email} onChange={set("email")} data-testid="assistant-lead-email" />
      <input className={inputCls} type="tel" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} data-testid="assistant-lead-phone" />
      {err && <p className="text-xs text-red-600" data-testid="assistant-lead-error">{err}</p>}
      <button type="submit" disabled={busy} className="w-full rounded-lg bg-[#C8A96B] text-[#0A2342] text-sm font-semibold py-2 hover:bg-[#b8995b] disabled:opacity-60 transition-colors" data-testid="assistant-lead-submit">
        {busy ? "Sending…" : "Send me my shortlist"}
      </button>
    </form>
  );
};
